angular.module('impactx.confirmation').service('ConfirmationService', ConfirmationService);

ConfirmationService.$inject = ['$mdDialog'];

function ConfirmationService($mdDialog) {
    return {
        showConfirmationDialog: function (callBackFunction, event, warningLabel, saveLabel, abortLabel, question, params) {
            $mdDialog.show({
                controller: "ConfirmationCtrl",
                controllerAs: "confirmationCtrl",
                templateUrl: "shared/confirmation/templates/confirmation.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    warning: warningLabel,
                    saveLabel: saveLabel,
                    abortLabel: abortLabel,
                    question: question
                }
            }).then(function () {
                callBackFunction(event, params);
            }, function () {
            });
        },
        showConfirmationDialogNoCallBack: function (event, warningLabel, saveLabel, abortLabel, question, params) {
            return $mdDialog.show({
                controller: "ConfirmationCtrl",
                controllerAs: "confirmationCtrl",
                templateUrl: "shared/confirmation/templates/confirmation.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    warning: warningLabel,
                    saveLabel: saveLabel,
                    abortLabel: abortLabel,
                    question: question
                }
            });
        },
        showHTMLConfirmationDialog: function (callBackFunction, event, warningLabel, saveLabel, abortLabel, question, params) {
            $mdDialog.show({
                controller: "ConfirmationCtrl",
                controllerAs: "confirmationCtrl",
                templateUrl: "shared/confirmation/templates/confirmation_html.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                    warning: warningLabel,
                    saveLabel: saveLabel,
                    abortLabel: abortLabel,
                    question: question
                }
            }).then(function () {
                callBackFunction(event, params);
            }, function () {
            });
        }
    }
}